<template>
  <div v-if="gaCampaign">
    <div class="flex justify-between">
      <span
        :class="{
          'inline-block': true,
          'bg-gray-200': true,
          'px-3': true,
          'py-1': true,
          'leading-snug': true,
          rounded: true,
          'text-xs': true,
          'text-gray-900': true,
          capitalize: true,
          'font-medium': true,
          'select-none': true,
          'mb-2': true,
        }"
      >
        Googla Ads Campaign
      </span>

      <span
        :class="{
          'inline-block': true,
          'bg-green-200': gaCampaign.status_name === 'ENABLED',
          'bg-gray-200': gaCampaign.status_name !== 'ENABLED',
          'px-3': true,
          'py-1': true,
          'leading-snug': true,
          rounded: true,
          'text-xs': true,
          'text-green-900': gaCampaign.status_name === 'ENABLED',
          'text-gray-900': gaCampaign.status_name !== 'ENABLED',
          capitalize: true,
          'font-medium': true,
          'select-none': true,
          'mb-2': true,
        }"
      >
        {{ gaCampaign.status_name }}
      </span>
    </div>

    <div class="mt-2">
      <span class="block font-medium text-sm capitalize text-gray-600">Καμπάνια</span>
      {{ gaCampaign.name }}
    </div>
    <div class="mt-4">
      <ul>
        <li class="flex justify-between">
          <span class="block font-medium text-sm capitalize text-gray-600">Immpressions</span>
          {{ impressions }}
        </li>

        <li class="flex justify-between mt-2">
          <span class="block font-medium text-sm capitalize text-gray-600">Clicks</span>
          {{ clicks }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  name: 'ChannableGoogleAdsCampaign',
  props: {
    gaCampaign: {
      type: Object,
      default: null,
    },
  },
  computed: {
    impressions() {
      return this.formatNumber(this.gaCampaign.lifetimeReport.impressions);
    },
    clicks() {
      return this.formatNumber(this.gaCampaign.lifetimeReport.clicks);
    },
  },

  methods: {
    formatNumber(value) {
      return Numbro(value).format({
        thousandSeparated: true,
        average: value > 100000,
        mantissa: value > 100000 ? 1 : 0,
      });
    },
  },
};
</script>
